<template>
  <div class="p-report-download-site l-block">
    <div class="l-block__content">
      <div class="l-block__header">
        <TitleSub level="h3">
          月間サイト分析レポート
        </TitleSub>
        <p class="p-report-download-site__description">
          オーガニック検索上の問題点や新たな気づきを定量的に調査・分析したレポートをダウンロード。<br />月初4～9日の間にレポートは完成します。レポートに何か問題がございましたら、お問い合わせをお願いいたします。
        </p>
        <ul class="p-report-download-site-notes">
          <li class="p-report-download-site-notes__item">
            <Icon2 variant="attention" :size="14" />
            GA4が連携されていないサイトはレポートが作成されませんのでご対応をお願いします。
          </li>
          <li class="p-report-download-site-notes__item">
            <Icon2 variant="attention" :size="14" />
            Microsoft
            Edgeを使われている場合、レポートのダウンロードに失敗することがあります。対応方法は
            <a
              href="https://support.searchwrite.jp/hc/ja/articles/6305556678799"
              target="_blank"
              class="c-link--blank"
              >こちらをご確認ください</a
            >
          </li>
        </ul>
      </div>
      <ListReportSite
        :items="data.items"
        :project="project"
        :isLoading="isLoading"
        @download="getList"
      />
    </div>
  </div>
</template>

<script>
import ListReportSite from '@/components/reportDownload/ListReportSite';
import TitleSub from '@/components/TitleSub';
import apiProjects from '@/api/projects';
import Icon2 from '@/components/Icon2';

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    ListReportSite,
    TitleSub,
    Icon2
  },
  data() {
    return {
      data: {
        items: []
      },
      isLoading: true
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      return apiProjects.monthlyReports.list
        .get(this.auth.idToken, this.project.id)
        .then(response => {
          this.data.items = response.data.items;
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
        });
    }
  }
};
</script>
